// the onboarding context lives apart from the provider so consumers (OrientationLayer, StudentEntry) never import the demo workspace
import { createContext, useContext } from "react";
export const OnboardingContext = createContext(null);
export const useOnboarding = () => useContext(OnboardingContext);
